module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraLight.2945b5f.woff";